import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import _ from "lodash";
import MiniDrawer from "../../Components/Drawer";
import { getApiData, putApiData, deleteApiData, axiosFormDataRequest } from "../../Apis/apiHelper";
import axios from "axios";
import BaseSetting from "../../Apis/setting";
import { toast } from "react-toastify";
import CModal from "../../Components/CModal";
import CInput from "../../Components/CInput";
import CButton from "../../Components/CButton";
import BaseColor from "../../Config/Color";
import { FontFamily } from "../../Config/theme";

const PRIORITY_OPTIONS = [1, 2, 3, 4];

const Advertisement = () => {
  const [adList, setAdList] = useState([]);
  const [pageLoad, setPageLoad] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [createBtnLoading, setCreateBtnLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [imageTitle, setImageTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [imageUploadedUrl, setImageUploadedUrl] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [priority, setPriority] = useState(1);

  const [titleError, setTitleError] = useState("");
  const [redirectUrlError, setRedirectUrlError] = useState("");
  const [dateError, setDateError] = useState("");

  useEffect(() => {
    setPageLoad(true);
    getAdvertisementList();
  }, []);

  const getAdvertisementList = () => {
    const endpoint = BaseSetting.endpoint.advertisementList;
    getApiData(endpoint, "GET", {})
      .then((result) => {
        const data = result?.data;
        if (_.isArray(data)) {
          setAdList(data);
        } else if (data && _.isArray(data.list)) {
          setAdList(data.list);
        } else if (data && _.isArray(data.advertisements)) {
          setAdList(data.advertisements);
        } else {
          setAdList([]);
        }
        setPageLoad(false);
      })
      .catch(() => {
        setAdList([]);
        setPageLoad(false);
      });
  };

  // const uploadImage = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const form = new FormData();
  //     form.append("image", file);
  //     const endpoint = BaseSetting.endpoint.imageUpload;
  //     getAxiosApi(endpoint, "post", form)
  //       .then((res) => {
  //         const url =
  //           res?.data?.url ||
  //           res?.data?.image_url ||
  //           res?.url ||
  //           res?.image_url;
  //         if (url) resolve(url);
  //         else reject(new Error("No image URL in response"));
  //       })
  //       .catch(reject);
  //   });
  // };

  const resetForm = () => {
    setTitle("");
    setImageTitle("");
    setImageFile(null);
    setImagePreview("");
    setImageUploadedUrl("");
    setRedirectUrl("");
    setStartDate("");
    setEndDate("");
    setIsActive(true);
    setPriority(1);
    setTitleError("");
    setRedirectUrlError("");
    setDateError("");
    setEditId("");
    setIsEditModal(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast("Please select an image file", { type: "error" });
        return;
      }
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setImageUploadedUrl("");
    }
  };

  const removeImage = () => {
    setImageFile(null);
    setImagePreview("");
    setImageUploadedUrl("");
  };

  const validate = () => {
    let hasError = false;
    setTitleError("");
    setRedirectUrlError("");
    setDateError("");

    if (!title?.trim()) {
      setTitleError("Title is required");
      hasError = true;
    }
    if (!redirectUrl?.trim()) {
      setRedirectUrlError("Redirect URL is required");
      hasError = true;
    }
    if (!startDate?.trim()) {
      setDateError("Start date is required");
      hasError = true;
    } else if (!endDate?.trim()) {
      setDateError("End date is required");
      hasError = true;
    } else if (new Date(endDate) < new Date(startDate)) {
      setDateError("End date must be after start date");
      hasError = true;
    }
    if (!isEditModal && !imageUploadedUrl && !imageFile) {
      toast("Please upload an image", { type: "error" });
      hasError = true;
    }
    return !hasError;
  };

  const handleCreateOrUpdate = async () => {
    if (!validate()) return;

    const trimmedTitle = title?.trim();
    const trimmedRedirectUrl = redirectUrl?.trim();
    const trimmedStartDate = startDate?.trim();
    const trimmedEndDate = endDate?.trim();

    if (!trimmedTitle || !trimmedRedirectUrl || !trimmedStartDate || !trimmedEndDate) {
      toast("Title, redirect URL, start date and end date are required.", { type: "error" });
      return;
    }

    setDisableBtn(true);
    setCreateBtnLoading(true);

    try {
      const formData = new FormData();

      formData.append("title", trimmedTitle);
      formData.append("image_title", imageTitle?.trim() || "");
      formData.append("redirect_url", trimmedRedirectUrl);
      formData.append("start_date", trimmedStartDate);
      formData.append("end_date", trimmedEndDate);
      formData.append("is_active", isActive ? 1 : 0);
      formData.append("priority", Number(priority));

      if (imageFile) {
        formData.append("image", imageFile);
      }

      if (isEditModal) {
        const endpoint = `${BaseSetting.apiUrl}${BaseSetting.endpoint.updateAdvertisement}/${editId}`;
        const result = await axiosFormDataRequest(endpoint, "PUT", formData, true);

        if (result?.status) {
          toast(result?.message || "Updated successfully", { type: "success" });
          setOpenModal(false);
          resetForm();
          getAdvertisementList();
        } else {
          toast(result?.message || "Update failed", { type: "error" });
        }
      } else {
        const endpoint = BaseSetting.apiUrl + BaseSetting.endpoint.createAdvertisement;
        const result = await axiosFormDataRequest(endpoint, "POST", formData, true);

        if (result?.status) {
          toast(result?.message || "Created successfully", { type: "success" });
          setOpenModal(false);
          resetForm();
          getAdvertisementList();
        } else {
          toast(result?.message || "Create failed", { type: "error" });
        }
      }
    } catch (err) {
      toast(err?.message || "Request failed", { type: "error" });
    } finally {
      setDisableBtn(false);
      setCreateBtnLoading(false);
    }
  };

  const handleToggleActive = (row) => {
    const endpoint = `${BaseSetting.endpoint.updateAdvertisement}/${row.id}`;
    putApiData(endpoint, {
      ...row,
      is_active: row.is_active === 1 ? 0 : 1,
    })
      .then((result) => {
        if (result?.status) {
          toast(result?.message || "Status updated", { type: "success" });
          getAdvertisementList();
        } else {
          toast(result?.message || "Failed", { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message || "Failed", { type: "error" });
      });
  };

  const handleDelete = (row) => {
    if (!window.confirm(`Delete advertisement "${row.title || row.id}"?`)) return;
    const endpoint = `${BaseSetting.endpoint.deleteAdvertisement}/${row.id}`;
    deleteApiData(endpoint)
      .then((result) => {
        const ok = result?.status === true || result?.success === true;
        if (ok && !result?.error) {
          toast(result?.message || "Deleted successfully", { type: "success" });
          getAdvertisementList();
        } else {
          toast(result?.message || "Delete failed", { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message || "Delete failed", { type: "error" });
      });
  };

  const openCreateModal = () => {
    resetForm();
    setOpenModal(true);
  };

  const openEditModal = (row) => {
    setEditId(row.id);
    setIsEditModal(true);
    setEditLoading(true);
    setOpenModal(true);
    const endpoint = `${BaseSetting.endpoint.getAdvertisementById}/${row.id}`;
    getApiData(endpoint, "GET", {})
      .then((result) => {
        const data = result?.data || result;
        setTitle(data.title || "");
        setImageTitle(data.image_title || "");
        setImageUploadedUrl(data.image || "");
        setImagePreview(data.image || "");
        setRedirectUrl(data.redirect_url || "");
        setStartDate(data.start_date ? String(data.start_date).slice(0, 10) : "");
        setEndDate(data.end_date ? String(data.end_date).slice(0, 10) : "");
        setIsActive(data.is_active === 1 || data.is_active === true);
        setPriority(Number(data.priority) || 1);
        setEditLoading(false);
      })
      .catch(() => {
        toast("Failed to load advertisement", { type: "error" });
        setEditLoading(false);
        setOpenModal(false);
      });
  };

  const columns = [
    {
      field: "id",
      headerName: "No.",
      flex: 0.25,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography sx={{ fontFamily: FontFamily.SemiBold }}>
          {params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1.1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Grid container alignItems="center" justifyContent="center" spacing={0.5} wrap="nowrap">
          <Grid item>
            <Tooltip title="Edit" placement="top" arrow>
              <Button
                size="small"
                onClick={() => openEditModal(params.row)}
                sx={{ minWidth: 36 }}
              >
                <Edit fontSize="small" />
              </Button>
            </Tooltip>
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={params.row.is_active === 1}
                  onChange={() => handleToggleActive(params.row)}
                  color="primary"
                  size="small"
                />
              }
              label={
                <Typography variant="caption" sx={{ fontFamily: FontFamily.Regular }}>
                  {params.row.is_active === 1 ? "Yes" : "No"}
                </Typography>
              }
              labelPlacement="start"
            />
          </Grid>
          <Grid item>
            <Tooltip title="Delete" placement="top" arrow>
              <Button
                size="small"
                color="error"
                onClick={() => handleDelete(params.row)}
                sx={{ minWidth: 36 }}
              >
                <Delete fontSize="small" />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "image",
      headerName: "Image",
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: BaseColor.primary, fontSize: 12 }}
          >
            View
          </a>
        ) : (
          "—"
        ),
    },
    {
      field: "redirect_url",
      headerName: "Redirect URL",
      flex: 1.2,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          noWrap
          sx={{ maxWidth: 180 }}
          title={params.value}
          variant="body2"
        >
          {params.value || "—"}
        </Typography>
      ),
    },
    {
      field: "start_date",
      headerName: "Start Date",
      flex: 0.85,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) =>
        params.value ? String(params.value).slice(0, 10) : "—",
    },
    {
      field: "end_date",
      headerName: "End Date",
      flex: 0.85,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) =>
        params.value ? String(params.value).slice(0, 10) : "—",
    },
    {
      field: "is_active",
      headerName: "Active",
      flex: 0.45,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          sx={{
            fontFamily: FontFamily.SemiBold,
            color: params.value === 1 ? "success.main" : "text.secondary",
          }}
        >
          {params.value === 1 ? "Yes" : "No"}
        </Typography>
      ),
    },
    {
      field: "priority",
      headerName: "Priority",
      flex: 0.45,
      headerAlign: "center",
      align: "center",
    },
  ];

  return (
    <Grid container>
      <MiniDrawer
        header="Advertisement"
        children={
          <>
            <Grid container justifyContent="space-between" alignItems="center">
              <Button
                variant="contained"
                onClick={openCreateModal}
                sx={{
                  background: BaseColor.primary,
                  "&:hover": { background: BaseColor.disablePrimary },
                }}
              >
                Create Advertisement
              </Button>
            </Grid>

            <Grid container mt={3}>
              {pageLoad ? (
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ width: "100%", minHeight: 400 }}
                >
                  <CircularProgress sx={{ color: BaseColor.primary }} />
                </Grid>
              ) : (
                <DataGrid
                  rows={adList}
                  columns={columns}
                  disableColumnFilter
                  disableColumnSelector
                  disableRowSelectionOnClick
                  autoHeight
                  getRowHeight={() => "auto"}
                  sx={{
                    width: "100%",
                    "& .MuiDataGrid-cell": { alignContent: "center" },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: BaseColor.offWhite,
                      fontFamily: FontFamily.SemiBold,
                    },
                  }}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                    },
                  }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                />
              )}
            </Grid>

            <CModal
              visible={openModal}
              title={isEditModal ? "Update Advertisement" : "Create Advertisement"}
              onClose={() => {
                setOpenModal(false);
                resetForm();
              }}
              style={{
                width: "100%",
                maxWidth: 700,
                margin: "0 auto",
                overflowX: "hidden",
              }}
              children={
                <Box sx={{ p: 2 }}>
                  {editLoading ? (
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 320 }}>
                      <CircularProgress sx={{ color: BaseColor.primary }} />
                    </Grid>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Title
                        </Typography>
                        <CInput
                          placeholder="Enter title"
                          value={title}
                          onChange={(v) => {
                            setTitle(v);
                            setTitleError("");
                          }}
                          errorMsg={titleError}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Image Title
                        </Typography>
                        <CInput
                          placeholder="Enter image title"
                          value={imageTitle}
                          onChange={setImageTitle}
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Image
                        </Typography>
                        <input
                          accept="image/*"
                          type="file"
                          id="ad-image-upload"
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                        />
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item>
                            <Button
                              variant="outlined"
                              component="label"
                              htmlFor="ad-image-upload"
                              size="medium"
                              sx={{ borderColor: BaseColor.primary, color: BaseColor.primary }}
                            >
                              Choose Image
                            </Button>
                          </Grid>
                          {(imagePreview || imageUploadedUrl) && (
                            <Grid item>
                              <Typography component="span" variant="body2" sx={{ color: "text.secondary", mr: 1 }}>
                                {imageFile ? imageFile.name : "Uploaded"}
                              </Typography>
                              <Button size="small" color="error" onClick={removeImage}>
                                Remove
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                        {(imagePreview || imageUploadedUrl) && (
                          <Box sx={{ mt: 2 }}>
                            <img
                              src={imagePreview || imageUploadedUrl}
                              alt="Preview"
                              style={{
                                maxWidth: "100%",
                                maxHeight: 140,
                                objectFit: "contain",
                                borderRadius: 8,
                                border: "1px solid #eee",
                              }}
                            />
                          </Box>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Redirect URL
                        </Typography>
                        <CInput
                          placeholder="Enter redirect URL"
                          value={redirectUrl}
                          onChange={(v) => {
                            setRedirectUrl(v);
                            setRedirectUrlError("");
                          }}
                          errorMsg={redirectUrlError}
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Start Date
                        </Typography>
                        <CInput
                          type="date"
                          value={startDate}
                          onChange={setStartDate}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          End Date
                        </Typography>
                        <CInput
                          type="date"
                          value={endDate}
                          onChange={(v) => {
                            setEndDate(v);
                            setDateError("");
                          }}
                          sx={{ width: "100%" }}
                        />
                        {dateError && (
                          <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                            {dateError}
                          </Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ fontFamily: FontFamily.SemiBold, mb: 1.5, display: "block" }}>
                          Priority
                        </Typography>
                        <Select
                          fullWidth
                          size="small"
                          value={priority}
                          onChange={(e) => setPriority(Number(e.target.value))}
                          displayEmpty
                          sx={{
                            borderRadius: 1,
                            backgroundColor: BaseColor.whiteColor,
                            fontFamily: FontFamily.Regular,
                            height: 40,
                          }}
                        >
                          {PRIORITY_OPTIONS.map((p) => (
                            <MenuItem key={p} value={p}>
                              {p}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={6} sx={{ display: "flex", alignItems: "center" }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={isActive}
                              onChange={(e) => setIsActive(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <Typography sx={{ fontFamily: FontFamily.Regular }}>
                              Is Active — {isActive ? "Yes" : "No"}
                            </Typography>
                          }
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} />
                      </Grid>

                      <Grid item xs={6}>
                        <CButton
                          variant="contained"
                          onClick={handleCreateOrUpdate}
                          disabled={disableBtn}
                          loading={createBtnLoading}
                          style={{ width: "100%" }}
                        >
                          {isEditModal ? "Update" : "Create"}
                        </CButton>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setOpenModal(false);
                            resetForm();
                          }}
                          disabled={disableBtn}
                          style={{ width: "100%" }}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              }
            />
          </>
        }
      />
    </Grid>
  );
};

export default Advertisement;
